import styled from '@emotion/styled';
import { shineOnMe, palette, remCalc, sizeMap } from '../../css';

const sizeFromLevel = level => sizeMap[Object.keys(sizeMap).reverse()[level]];

const setWidth = width => {
    return Math.min(100, Math.max(0, width + Math.round(20 * Math.random())));
};

const StyledTitlePlaceholder = styled('div')(
    () => {
        const shineColor = 'rgba(255, 255, 255, .025)';
        return {
            ...shineOnMe(shineColor),
            backgroundColor: palette('primary', 'mainNav'),
        };
    },
    ({ width, level }) => ({
        width: width !== null ? `${setWidth(width)}%` : '100%',
        height: remCalc(sizeFromLevel(level)),
        marginTop: remCalc(sizeFromLevel(level) / 2),
    }),
);

export { StyledTitlePlaceholder };
